/**
 * English copy for `BirthChartFlow` (HORO-10360). Composed into
 * `i18n/locales/en/translation.js` under `birthChart.flow`, so keys are read
 * as `birthChart.flow.<path>`.
 */
const copy = {
    close: 'Close',
    continue: 'Continue',
    intro: {
        title: 'Unlock your birth chart',
        body: "Your sun sign is one placement. Your chart is all of them. Tell me when and where you were born, and I'll read it for you.",
        bullets: {
            placements: 'Your sun, moon and rising, and what each says about you',
            themes: 'The life themes your chart keeps coming back to',
            planets: 'What each planet is stirring up in your life',
            saved: 'Saved, so every reading after this starts from your chart'
        },
        cta: 'Get My Birth Chart'
    },
    date: {
        title: 'Add your date of birth'
    },
    time: {
        title: 'Add your time of birth',
        unknown: "Don't know your time? Use 12:00 PM"
    },
    place: {
        title: 'Add your location of birth',
        placeholder: 'Enter location'
    },
    verify: {
        title: 'Verify Details',
        date: 'Date of birth :',
        time: 'Time of birth :',
        place: 'Location of birth :',
        timeUnknown: '{{time}} (time unknown)',
        edit: 'Edit {{field}}',
        generate: 'Generate Birth Chart',
        verify: 'Verify',
        saving: 'Saving…',
        saveFailed: "Couldn't save your birth date. Try again?"
    },
    loading: {
        title: 'traveling back in time',
        locating: 'Locating {{city}}',
        locatingFallback: 'Locating your birthplace',
        reading: 'Reading {{date}}',
        placing: 'Placing 10 planets in houses',
        rising: 'Calculating rising sign',
        failed: "We couldn't build your chart. Please try again."
    }
};

export default copy;
